import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

const CardPlaceHolder = (props) => {
	return (
		<div className="card-form-place-holder">
			<div>Insert Element Here</div>
		</div>
	);
};

CardPlaceHolder.propTypes = {
	text: PropTypes.string,
	show: PropTypes.bool
};

CardPlaceHolder.defaultProps = {
	text: 'Dropzone',
	show: true
};

export default injectIntl(CardPlaceHolder);
